import React, { useEffect, useState } from "react";
import { FxmsPopup } from "../windows/FxWindows";
import { FxResource } from "./FxResource";
import Button from "@mui/material/Button";
import { UI_SignUp_CU } from "../../vup/ui/UI_SignUp_CU";

export const FxOpenButton = (props) => {
  const { opObj, selectedData, selectedDataId, className, flag, onClick, refershGridData } = props;
  const [modalOpen, setModalOpen] = useState(false);
  const [title, setTitle] = useState(props.title ? props.title : opObj.opTitle);
  const closeModal = (e) => {
    setModalOpen(false);
    if(onClick) onClick();
  };
  const openModal = () => {
    setModalOpen(true);
  };

  useEffect(() => {}, []);

  if (opObj && opObj.opTypeCd === "UI") {
    return (
      <>
        <Button
          className={"button " + className}
          id={opObj.opId}
          onClick={openModal}
        >
          {title}
        </Button>
        <FxmsPopup
          open={modalOpen}
          closeModal={closeModal}
          dialogTitle={title}
          opObj={opObj}
        >
          {flag ? <UI_SignUp_CU onComplete={closeModal} /> : <FxResource menu={opObj} selectedData={selectedData} selectedDataId={selectedDataId} onCloseBtnClick={closeModal} refershGridData={refershGridData} />}
        </FxmsPopup>
      </>
    );
  } else {
    return <></>;
  }
};
